import { createSelector, createStructuredSelector } from 'reselect';
import {
    eventEndDateSelector,
    eventStartDateSelector,
    eventTimezoneSelector,
    eventIdSelector,
    accountIdSelector,
} from './EventSelectors';
import { loginLoadingStateSelector, getRedirectRingUrl } from './LoginSelectors';
import { eventGroupIdSelector } from './EventSelectors';
import FeatureToggleUtils from 'FeatureToggleUtils';
import { meIdSelector } from './MeSelectors';

const ringSettingsSelector = state => state.ringReducer;

export const isRingWorksSelector = createSelector(
    ringSettingsSelector,
    (ringSettings) => ringSettings.isRingWorks
);

export const isRingAvailableSelector = createSelector(
    ringSettingsSelector,
    (ringSettings) => {
        const isRingFeatureEnabled = FeatureToggleUtils.isFeatureEnabled('ring');
        return isRingFeatureEnabled && ringSettings.available;
    }
);

export const isShowCustomBannerDataSelector = createSelector(
    ringSettingsSelector,
    (ringSettings) => ringSettings.customization?.showCustomBannerData
);

export const getCustomBannerHeaderSelector = createSelector(
    ringSettingsSelector,
    (ringSettings) => ringSettings.customization?.customBannerHeader
);

export const getCustomBannerTextSelector = createSelector(
    ringSettingsSelector,
    (ringSettings) => ringSettings.customization?.customBannerText
);


export const getCustomBannerCTASelector = createSelector(
    ringSettingsSelector,
    (ringSettings) => ringSettings.customization?.customBannerCTA
);

export const virtualBannerSelector = createStructuredSelector({
    isRingWorks: isRingWorksSelector,
    eventTimeZone: eventTimezoneSelector,
    startDate: eventStartDateSelector,
    endDate: eventEndDateSelector,
    loginV2LoadingState: loginLoadingStateSelector,
    eventGroupId: eventGroupIdSelector,
    authDropRedirectRing: getRedirectRingUrl,
    userId: meIdSelector,
    eventId: eventIdSelector,
    accountId: accountIdSelector,
    isShowCustomBannerData: isShowCustomBannerDataSelector,
    customBannerHeader: getCustomBannerHeaderSelector,
    customBannerText: getCustomBannerTextSelector,
    customBannerCTA: getCustomBannerCTASelector
});
